import {
  Autocomplete,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  Icon,
  InputAdornment,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "layouts/employees/employee_view/components/Header";
import { useEffect, useMemo, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import FormField from "layouts/pages/account/components/FormField";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { FileUpload, Search, TouchApp } from "@mui/icons-material";
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Footer from "examples/Footer";
import moment from "moment";
import { LeaveBalanceComponent } from "./Components/LeaveBalance";
import { LeaveHistoryComponent } from "./Components/LeaveHistory";
import { LeaveTransactionComponent } from "./Components/LeaveTransaction";
import rgba from "assets/theme/functions/rgba";
import colors from "assets/theme/base/colors";
import MDAvatar from "components/MDAvatar";
import { useTheme } from "@mui/material/styles";
import { useMaterialUIController } from "context";
import { base_url } from "services";
import ApproveLeave from "layouts/managerdesk/approveLeave";
import { SelectEmployee } from "components/SelectEmployee";

export function Leaves({ permissions, modulePermissions }) {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const user_id = loggedUser?.employee_id;
  const org_id = loggedUser?.org_id;
  const [employee, setEmployee] = useState({});
  const [employees, setEmployees] = useState([]);
  const [reload, setReload] = useState();
  const [employeeLeaveBalance, setEmployeeLeaveBalance] = useState([]);
  const [createDialog, setCreateDialog] = useState(false);
  const [leaveRequestPayload, setLeaveRequestPayload] = useState({
    start_time: moment(new Date()).format("HH:mm"),
    start_date: moment(new Date()).format("YYYY-MM-DD"),
    end_date: moment(
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      )
    ).format("YYYY-MM-DD"),
    number_of_days: 1,
  });
  const [RemarkError, setRemarkError] = useState("");
  const [LeaveHourError, setLeaveHourError] = useState("");
  const [LeaveBalanceError, setLeaveBalanceError] = useState("");
  const [startTimeError, setStartTimeError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
	const [tabComponents, setTabComponents] = useState([]);
  const [selectedTab, setSelectedTab] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [adminFilters, setAdminFilters] = useState({
    employee: user_id || null,
    manager: null,
    month: moment().format("YYYY-MM"),
    status: "pending",
  });
  const hasPermissionLike = (value) =>
    permissions?.some((permission) => permission === value || permission?.includes("leave_admin"));
  const hasLeaveAdmin =
    hasPermissionLike(modulePermissions?.leave_admin_permission) ||
    hasPermissionLike(modulePermissions?.balance_admin_permission) ||
    hasPermissionLike(modulePermissions?.transaction_admin_permission) ||
    hasPermissionLike(modulePermissions?.approval_admin_permission);
  const showStatusFilter = ["Leave History", "Approvals"].includes(selectedTab?.label);
  const updateAdminFilter = (key, value) => {
    setAdminFilters((current) => ({ ...current, [key]: value }));
  };

  const ui = {
    page: darkMode ? palette.background.default : colors.background.default,
    surface: darkMode ? palette.background.card : colors.white.main,
    soft: darkMode ? palette.background.muted : colors.background.elevated,
    border: darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.14),
    title: darkMode ? palette.text.focus : colors.dark.main,
    body: darkMode ? palette.text.main : colors.secondary.main,
    hero: darkMode
      ? `linear-gradient(180deg, ${rgba(palette.background.default, 0.98)} 0%, ${rgba(
          palette.background.card,
          0.94
        )} 100%)`
      : `linear-gradient(180deg, ${rgba(colors.light.main, 0.94)} 0%, ${rgba(
          colors.white.main,
          0.98
        )} 100%)`,
    panel: darkMode
      ? `linear-gradient(135deg, ${rgba(palette.background.card, 0.98)} 0%, ${rgba(
          palette.background.muted,
          0.96
        )} 100%)`
      : `linear-gradient(135deg, ${colors.background.default} 0%, ${colors.background.accent} 100%)`,
  };


  useEffect(() => {
    if (createDialog) {
      setRemarkError("");
      setLeaveHourError("");
      setLeaveBalanceError("");
      setStartTimeError("");
      setStartDateError("");
      setEndDateError("");
    } else {
      setLeaveRequestPayload({
        start_time: moment(new Date()).format("HH:mm"),
        start_date: moment(new Date()).format("YYYY-MM-DD"),
        end_date: moment(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          )
        ).format("YYYY-MM-DD"),
        number_of_days: 1,
      });
    }
  }, [createDialog]);
  useEffect(() => {
    getEmployee();
    getEmployees();
    getEmployeeLeaveBalance();
  }, []);

  useEffect(() => {
    getEmployeeLeaveBalance();
  }, [reload]);

	useEffect(() => {
    const tabs = [
      {
        label: "Leave History",
        component: (
          <LeaveHistoryComponent
            permissions={permissions}
            modulePermissions={modulePermissions}
            setReload={setReload}
            reload={reload}
            employee={employee}
            employeeLeaveBalance={employeeLeaveBalance}
            employees={employees}
            leaveAdmin={hasLeaveAdmin}
            adminFilters={adminFilters}
          ></LeaveHistoryComponent>
        ),
        icon: <FileUpload />,
        visible:
          permissions?.includes(modulePermissions?.list_permission) ||
          permissions?.includes(modulePermissions?.own_list_permission) ||
          permissions?.includes(modulePermissions?.leave_admin_permission),
      },
      {
        label: "Leave Transaction",
        component: (
          <LeaveTransactionComponent
            employees={employees}
            setReload={setReload}
            reload={reload}
            leaveAdmin={hasLeaveAdmin}
            adminFilters={adminFilters}
          ></LeaveTransactionComponent>
        ),
        icon: <FileUpload />,
        visible:
          permissions?.includes(modulePermissions?.transaction_list_permission) ||
          permissions?.includes(modulePermissions?.transaction_owner_list_permission) ||
          permissions?.includes(modulePermissions?.transaction_admin_permission),
      },
      {
        label: "Leave Balance",
        component: <LeaveBalanceComponent
          setReload={setReload}
          reload={reload}
          leaveAdmin={hasLeaveAdmin}
          adminFilters={adminFilters}
        ></LeaveBalanceComponent>,
        icon: <FileUpload />,
        visible:
          permissions?.includes(modulePermissions?.balance_list_permission) ||
          permissions?.includes(modulePermissions?.balance_admin_permission),
      },
      {
        label: "Approvals",
        component: <ApproveLeave leaveAdmin={hasLeaveAdmin} employees={employees} embedded adminFilters={adminFilters} />,
        icon: <FileUpload />,
        visible:
          permissions?.includes(modulePermissions?.approval_admin_permission) ||
          permissions?.includes(modulePermissions?.approval_list_permission),
      },
    ];
    const visibleTabs = tabs.filter((tab) => tab.visible);
    setTabComponents(visibleTabs);
    setSelectedTab((current) => visibleTabs.find((tab) => tab.label === current?.label) || visibleTabs[0] || null);
  }, [employees, reload, employee, employeeLeaveBalance, permissions, modulePermissions, hasLeaveAdmin, adminFilters]);

  async function getEmployee() {
    var res = await ApiCalls.getEmployee(user_id);
    if (res.success && res.code == 200) {
      setEmployee(res.data);
    } else {
    }
  }
  async function getEmployees() {
    var res = await ApiCalls.getEmployeesList("?status=active");
    if (res.success && res.code == 200) {
      setEmployees(res.data);
    } else {
    }
  }
  // get leave balance
  async function getEmployeeLeaveBalance() {
    var res = await ApiCalls.getEmployeeLeaveBalance(user_id);
    if (res.success && res.code == 200) {
      setEmployeeLeaveBalance(res.data);
    }
  }

  async function createLeaveRequest() {
    var hasError = false;

    // count non-space characters only so strings with only spaces don't pass
    const nonSpaceLength = leaveRequestPayload.reason
      ? leaveRequestPayload.reason.replace(/\s+/g, "").length
      : 0;
    if (!leaveRequestPayload.reason || nonSpaceLength < 50) {
      hasError = true;
      setRemarkError("Remark must have at least 50 non-space characters.");
    } else {
      setRemarkError("");
    }

    if (leaveRequestPayload.leave_category_name == undefined) {
      hasError = true;
      setLeaveBalanceError("Leave Balance is required")
    } else {
      setLeaveBalanceError("")
    }
    if (leaveRequestPayload.number_of_hours == undefined) {
      hasError = true;
      setLeaveHourError("Hours is required")
    } else {
      setLeaveHourError("")
    }
    if (!hasError) {
      var numberOfHours;
      if (leaveRequestPayload.number_of_hours >= 8) {
        var res = await ApiCalls.getShiftHours(
          `?start_date=${leaveRequestPayload.start_date}&end_date=${leaveRequestPayload.end_date}&employee_id=${user_id}`
        );
        if (res.success) {
          numberOfHours = res.data.total_shift_hours;
        }
      } else {
        numberOfHours = leaveRequestPayload.number_of_hours;
      }
      if (numberOfHours != undefined) {
        var data = {
          start_date: leaveRequestPayload.start_date,
          end_date: leaveRequestPayload.number_of_hours >= 8 ? leaveRequestPayload.end_date : leaveRequestPayload.start_date,
          number_of_hours: numberOfHours,
          status: "pending",
          reason: leaveRequestPayload.reason,
          org: org_id,
          employee: user_id,
          leave_category_name: leaveRequestPayload.leave_category_name,
        };

        var res = await ApiCalls.postLeaveRequest(data, false);
        if (res.success && res.code == 201) {
          setCreateDialog(false);
          setReload(Math.random().toString())
          getEmployeeLeaveBalance();
        } else {
          setCreateDialog(false);
        }
      }
    }

  }

  const handleSubmit = async () => {
    createLeaveRequest();
  };

		const metrics = useMemo(() => {
			const total = 25;
			const active =22;
			const notice = 0;
	
			return [
				{
					label: "Total employees",
					value: total,
					helper: "Visible across the directory",
				},
				{
					label: "Active",
					value: active,
					helper: "Currently working",
				},
				{
					label: "On notice",
					value: notice,
					helper: "Needs follow-up",
				},
			];
		}, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
			<MDBox 
			  p={3}
				sx={{
					borderBottom: `1px solid ${ui.border}`,
					background: ui.hero,
				}}>
        <MDBox>
					<MDBox
						mb={3}
						sx={{
							p: { xs: 3, md:1.5 },
							borderRadius: "28px",
							background:
								`linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
							color: colors.white.main,
							position: "relative",
							overflow: "hidden",
						}}
					>
						<MDBox
							sx={{
								position: "absolute",
								inset: 0,
								background:
									`radial-gradient(circle at top right, ${rgba(colors.white.main, 0.18)}, transparent 28%), radial-gradient(circle at bottom left, ${rgba(colors.white.main, 0.1)}, transparent 30%)`,
								pointerEvents: "none",
							}}
						/>
						<Grid container spacing={3} position="relative"  p={1}>
							<Grid item xs={12} lg={7} sx={{display : 'flex', alignItems: "center",}}>
								<MDBox sx={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
									<MDBox mt={2}>
										<MDAvatar
											variant="square"
											src={employee?.img ? (employee?.img.includes("http") ? employee?.img : base_url + employee?.img) : ''}
											alt={`${employee?.user?.firstname}${employee?.user?.lastname}` || "profile-image"}
											size="xl"
											shadow="sm"
											sx={{
												cursor: "pointer",
												position: "relative",
												borderRadius: "16px",
											}}
										/>
									</MDBox>
									<MDBox sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "flex-start" }}>
										<MDTypography variant="h4" color="white" mt={2} >
											{employee?.user?.firstname} {employee?.user?.lastname}
										</MDTypography>
										<MDTypography variant="body2" color="white" sx={{ opacity: 0.82, maxWidth: 620 }}>
											Track balances, approve requests quickly, and keep operations running without disruption.
										</MDTypography>
									</MDBox>
								</MDBox>
							</Grid>
							<Grid item xs={12} lg={5} mt={2}>
								<Grid container spacing={2} display="flex" justifyContent='end'>
									{employeeLeaveBalance && Object.keys(employeeLeaveBalance).map((type) => (
										<Grid item xs={12} sm={4} lg={12} xl={4} key={type}>
											<Card
												sx={{
													p: 2.25,
													height: "90%",
													backgroundColor: rgba(colors.white.main, 0.12),
													border: `1px solid ${rgba(colors.white.main, 0.14)}`,
													backdropFilter: "blur(12px)",
													color: "white",
												}}
											>
												<MDTypography variant="caption" sx={{ color: rgba(colors.white.main, 0.72) }}>
													{type.replaceAll("_", " ").toUpperCase()}
												</MDTypography>
												<MDTypography variant="h5" color="white" mt={0.5}>
													{employeeLeaveBalance[type] + " Hours"}
												</MDTypography>
											</Card>
										</Grid>
									))}
								</Grid>
							</Grid>
						</Grid>
					</MDBox>
          {/*<Card sx={{ padding: 2 }}>
            <MDBox display="flex">
              <Grid
                container
                spacing={3}
                alignContent="center"
                alignItems="center"
              >
                <Grid item xl={5}>
                  <Card>
                    <Header data={employee}></Header>
                  </Card>
                </Grid>
                {Object.keys(employeeLeaveBalance)?.map((e) => (
                  <Grid item>
                    <Card sx={{ height: "100%", padding: 2 }}>
                      <MDBox sx={{ justifyContent: "center", width: "110px" }}>
                        <MDTypography variant="h6" textTransform="capitalize">
                          {e.replaceAll("_", " ")}
                        </MDTypography>
                        <MDTypography variant="h6" textTransform="capitalize">
                          {employeeLeaveBalance[e] + " Hours"}
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              {permissions?.includes(modulePermissions?.create_permission) && (
                <Fab
                  color="info"
                  sx={{ padding: "30px" }}
                  onClick={() => {
                    setCreateDialog(true);
                  }}
                >
                  <MDTypography variant="h6" color="white">
                    +
                  </MDTypography>
                </Fab>
              )}
            </MDBox>
          </Card>*/}
        </MDBox>

				<MDBox
          sx={{
            padding: "20px",
            background: ui.panel,
            borderRadius: "28px",
            border: `1px solid ${ui.border}`,
            boxShadow: darkMode ? "0 20px 40px rgba(2, 6, 23, 0.28)" : "none",
          }}
        >

				<Stack
					direction={{ xs: "column", lg: "row" }}
					justifyContent="space-between"
					alignItems={{ xs: "flex-start", lg: "center" }}
					spacing={2}
					mb={3}
					mt={2}
        >
					<MDBox style={{ display: "flex", alignItems: "center", gap: 12 }}>
						<MDBox
							sx={{
								width: 52,
								height: 52,
								borderRadius: "16px",
								display: "grid",
								placeItems: "center",
								background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
								color: colors.white.main,
							}}
						>
							<TouchApp />
						</MDBox>
						<MDBox>
            <MDTypography variant="h4" fontWeight="bold">
              Leaves
            </MDTypography>
            <MDTypography variant="body2" sx={{ color: ui.body }}>
              Fast, clear, and role-ready ERP workflows.
            </MDTypography>
						</MDBox>
          </MDBox>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.25}
            width={{ xs: "100%", lg: "auto" }}
            alignItems={{ xs: "stretch", sm: "center" }}
          >
            {/*<TextField
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              placeholder="Search announcements and updates..."
              size="small"
              sx={{ minWidth: { xs: "100%", sm: 320 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: colors.secondary.main, fontSize: 18 }} />
                  </InputAdornment>
                ),
              }}
            />*/}
            {/*<MDBox
              sx={{
                px: 2,
                py: 1.15,
                borderRadius: "14px",
                backgroundColor: colors.warning.main,
                border: `1px solid ${rgba(colors.secondary.main, 0.18)}`,
                color: colors.white.main,
                fontWeight: 700,
                fontSize: "0.875rem",
                whiteSpace: "nowrap",
              }}
            >
              {moment().format("DD MMM YYYY")}
            </MDBox>*/}
						  <MDButton
						  //variant="gradient"
              color="info"
              onClick={() => {setCreateDialog(true)}}
              disabled={!permissions?.includes(modulePermissions?.create_permission)}
              sx={{
                height: 55,
                px: 2.25,
                borderRadius: "14px",
                borderColor: ui.border,
                color: colors.white.main,
                whiteSpace: "nowrap",
                "&:hover": {
                  borderColor: rgba(colors.info.main, 0.28),
                },
              }}
            >
              Create Leave Request
            </MDButton>
          </Stack>
        </Stack>
        <MDBox mb={2}>
          <MDBox sx={{ maxWidth: "100%", overflowX: "auto", pb: 0.5 }}>
            <Tabs
              value={selectedTab?.label || false}
              onChange={(event, value) => {
                setSelectedTab(tabComponents.find((tab) => tab.label === value));
              }}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                minHeight: 0,
                "& .MuiTabs-indicator": {
                  display: "none",
                },
                "& .MuiTabs-flexContainer": {
                  flexWrap: "nowrap",
                  gap: 6,
                },
                "& .MuiTab-root": {
                  minHeight: 42,
                  borderRadius: "12px",
                  textTransform: "none",
                  fontWeight: 700,
                  color: ui.body,
                  px: 2,
                  py: 1,
                  transition: "all 180ms ease",
                },
                "& .Mui-selected": {
                  color: `${colors.white.main} !important`,
                  background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                },
              }}
            >
              {tabComponents.map((tab) => (
                <Tab key={tab.label} label={tab.label} value={tab.label} />
              ))}
            </Tabs>
          </MDBox>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={1.25}
            alignItems={{ xs: "stretch", md: "center" }}
            justifyContent="flex-start"
            useFlexGap
            flexWrap="wrap"
            mt={2}
            sx={{ width: "100%" }}
          >
            {hasLeaveAdmin && (
              <>
                <MDBox sx={{ width: { xs: "100%", md: "calc(25% - 8px)" }, minWidth: { md: 220 }, flex: 1 }}>
                  <SelectEmployee
                    label="Employee"
                    placeholder="Employee"
                    fullWidth
                    value={adminFilters.employee}
                    onSelected={(value) => updateAdminFilter("employee", value)}
                  />
                </MDBox>
                <MDBox sx={{ width: { xs: "100%", md: "calc(25% - 8px)" }, minWidth: { md: 220 }, flex: 1 }}>
                  <SelectEmployee
                    label="Manager"
                    placeholder="Manager"
                    fullWidth
                    onSelected={(value) => updateAdminFilter("manager", value)}
                  />
                </MDBox>
              </>
            )}
            <TextField
              type="month"
              label="Month"
              value={adminFilters.month}
              onChange={(event) => updateAdminFilter("month", event.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{
                width: { xs: "100%", md: "calc(25% - 8px)" },
                minWidth: { md: 170 },
                flex: 1,
                "& .MuiOutlinedInput-root": {
                  minHeight: 56,
                  borderRadius: "14px",
                  backgroundColor: "var(--app-field-bg)",
                },
                "& .MuiInputLabel-root": {
                  color: "var(--app-text-secondary)",
                },
              }}
            />
            {showStatusFilter && (
              <TextField
                select
                SelectProps={{ native: true }}
                label="Status"
                value={adminFilters.status}
                onChange={(event) => updateAdminFilter("status", event.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  width: { xs: "100%", md: "calc(25% - 8px)" },
                  minWidth: { md: 150 },
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    minHeight: 56,
                    borderRadius: "14px",
                    backgroundColor: "var(--app-field-bg)",
                  },
                  "& .MuiInputLabel-root": {
                    color: "var(--app-text-secondary)",
                  },
                }}
              >
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
                <option value="all">All</option>
              </TextField>
            )}
          </Stack>
        </MDBox>
        <MDBox pt={1} justifyContent="center">
          {/*<Card sx={{ paddingLeft: 2 , background: `linear-gradient(135deg, ${colors.background.default} 0%, ${colors.background.accent} 100%)`,}}>*/}
						<MDBox>
							{selectedTab?.component}
						</MDBox>
          {/*</Card>*/}
        </MDBox>
        <Dialog
          PaperProps={{
            sx: {
              backgroundColor: ui.surface,
              boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
              width: "600px",
              height: "auto",
              maxWidth: "none",
              borderRadius: "20px",
              cursor: "pointer",
              border: `1px solid ${ui.border}`,
              backgroundImage: "none",
            },
          }}
          open={createDialog}
          onClose={() => {
            setCreateDialog(false);
          }}
        >
          <DialogTitle
            sx={{
              width: "100%",
              p: "20px",
              background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
              color: "white",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "white", fontWeight: "Medium" }}>
                Apply Leave
              </Typography>
              <Icon
                fontSize="medium"
                onClick={() => {
                  setCreateDialog(false);
                }}
              >
                close
              </Icon>
            </div>
          </DialogTitle>
          <DialogContent
            sx={{
              p: "15px",
            }}
          >
            <Card
              id="basic-info"
              sx={{
                overflow: "visible",
                padding: "15px",
                background: darkMode
                  ? `linear-gradient(180deg, ${palette.background.card} 0%, ${palette.background.muted} 100%)`
                  : `linear-gradient(180deg, ${colors.light.main} 0%, ${colors.background.accent} 100%)`,
                border: `1px solid ${ui.border}`,
              }}
            >
              {/* <MDBox
                p={3}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <MDTypography variant="h5">Apply for leave</MDTypography>
              </MDBox> */}
              <MDBox component="form" pb={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      // value={gender}
                      options={Object.keys(employeeLeaveBalance)}
                      onChange={(event, values) => {
                        setLeaveRequestPayload((state) => ({
                          ...state,
                          leave_category_name: values,
                        }));
                      }}
                      getOptionLabel={(v) =>
                        v?.replaceAll("_", " ") +
                        " (" +
                        employeeLeaveBalance[v] +
                        " hours)"
                      }
                      getOptionDisabled={(option) => employeeLeaveBalance[option] === 0}

                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          label="Leave Balance"
                          {...params}
                          placeholder="Select Leave Balance"
                          InputLabelProps={{ shrink: true }}
                          required
                          error={!!LeaveBalanceError}
                          helperText={LeaveBalanceError}
                          disabled={!Object.keys(employeeLeaveBalance).length}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      // value={gender}
                      disabled={!Object.keys(employeeLeaveBalance).length}
                      options={[
                        { name: "Full Day", hour: 8 },
                        { name: "Half Day", hour: 4 },
                        { name: "2 Hours", hour: 2 },
                      ]}
                      getOptionDisabled={(option) => {
                        const selectedCategory = leaveRequestPayload?.leave_category_name;
                        const remainingHours = employeeLeaveBalance[selectedCategory] || 0;
                        return option.hour > remainingHours;
                      }}
                      onChange={(event, values) => {
                        setLeaveRequestPayload((state) => ({
                          ...state,
                          number_of_hours: values?.hour,
                        }));
                      }}
                      getOptionLabel={(v) => v.name}
                      renderInput={(params) => (
                        <TextField
                          variant="standard"
                          label="Hours"
                          {...params}
                          placeholder="Select Hours"
                          InputLabelProps={{ shrink: true }}
                          required
                          error={!!LeaveHourError}
                          helperText={LeaveHourError}
                        />
                      )}
                    />
                    {/* <FormField
                      label="Number Of Days"
                      // placeholder="Volkov"
                      value={
                        leaveRequestPayload.number_of_days
                      }
                      onChange={(e) => {
                        setLeaveRequestPayload((state) => ({
                          ...state,
                          number_of_days: e.target.value,
                        }));
                      }}
                      inputProps={{  }}
                    /> */}
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormField
                          label="Start Date"
                          inputProps={{ type: "date" }}
                          placeholder="DD/MM/YY"
                          value={leaveRequestPayload.start_date}
                          onChange={(e) => {
                            setLeaveRequestPayload((state) => ({
                              ...state,
                              start_date: e.target.value,
                              // number_of_days: parseInt(
                              //   (new Date(leaveRequestPayload.end_date) -
                              //     new Date(e.target.value)) /
                              //     (1000 * 60 * 60 * 24),
                              //   10
                              // ),
                            }));
                            //   setEmployee({ ...Employee, dob: e.target.value });
                            //   setDob(e.target.value);
                          }}
                          error={!!startDateError}
                          helperText={startDateError}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {leaveRequestPayload?.number_of_hours == 8 ? (
                          <FormField
                            label="End Date"
                            inputProps={{ type: "date" }}
                            placeholder="DD/MM/YY"
                            value={leaveRequestPayload.end_date}
                            onChange={(e) => {
                              setLeaveRequestPayload((state) => ({
                                ...state,
                                end_date: e.target.value,
                              }));
                            }}

                          />
                        ) : (
                          <FormField
                            label="Start Time"
                            inputProps={{ type: "time" }}
                            value={leaveRequestPayload.start_time}
                            onChange={(e) => {
                              setLeaveRequestPayload((state) => ({
                                ...state,
                                end_date: state.start_date,
                                start_time: e.target.value,
                              }));
                            }}
                          />
                        )}
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <Grid container spacing={3}>
                          
                        </Grid>
                      </Grid> */}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      variant="standard"
                      label="Remark"
                      fullWidth
                      placeholder="Leave Remark.."
                      value={leaveRequestPayload.reason}
                      onChange={(e) => {
                        const value = e.target.value || "";
                        setLeaveRequestPayload((state) => ({
                          ...state,
                          reason: value,
                        }));

                        const nonSpaceLength = value.replace(/\s+/g, "").length;
                        if (!value || nonSpaceLength < 50) {
                          setRemarkError(
                            `Remark must have at least 50 non-space characters.`
                          );
                        } else {
                          setRemarkError("");
                        }
                      }}
                      required
                      error={!!RemarkError}
                      helperText={RemarkError}
                    />
                  </Grid>

                  {/* <Grid item xs={12} md={6}></Grid> */}
                </Grid>
                <MDBox pt={4} display="flex" justifyContent="center">
                  <MDButton
                    variant="gradient"
                    color="dark"
                    onClick={() => handleSubmit()}
                  >
                    Submit
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </DialogContent>
        </Dialog>
				</MDBox>
      </MDBox>
    </DashboardLayout>
  );
}
